import React from 'react';
import PropTypes from 'prop-types';
import ApplicationSection from '../ApplicationSection/ApplicationSection'
import JumptoSection from '../JumptoSection/JumptoSection';

/**
 * Application form section
 *
 * @param {object} props
 * @param {'references' | ''} props.type
 * @param {string} props.title
 * @param {object[]} props.questions
 * @param {string[]} props.references
 * @param {boolean} props.isLast
 *
 * @returns {ReactElement}
 */


const ExternalRoleForm = ({
    title= '',
    subTitle = '',
    herokuRoleDisplayName = '',
    externalFinancial= [],
    questions= [],
    iterationfield= [],
    iteration= [],
    references= [],
    sfid= '',
    errors,
    onChange= () => {},
    showExtraIterationModal= () => {},
    handleExtraIterationRemove= () => {},
    iteratableStepShowFirst =false,
    externalButton =false,
    maximumRecord='',
    buttonSecondaryColor,
    deleteApplicationDocument = () => {},
    allowApplicantUploadsAfterDeadline,
    dependentConfigsForVariousSteps,
    applicationId ,
    scholarship,
    sections,
    renderFormattedSections=()=>{},
    currectStepId,
    handlejumpto,
    submittedSteps = [],
    stepStatus = '',
    isMobileScreen = false,
    isIpadScreen= false,
  ...props
}) => {
  const getSections = renderFormattedSections(sections)

  return (
      <form className="application__form application__step">
          <ApplicationSection
            externalRoleList ={ externalFinancial }
            iterationfield={ iterationfield  }
            herokuRoleDisplayName = { herokuRoleDisplayName }
            key={sfid}
            errors = { errors }
            title={ title }
            subTitle = { subTitle }
            questions={ [] }
            showExtraIterationModal={showExtraIterationModal}
            handleExtraIterationRemove = {handleExtraIterationRemove}
            externalButton = {externalButton}
            maximumRecord={maximumRecord}
            deleteApplicationDocument = {deleteApplicationDocument}
            buttonSecondaryColor={buttonSecondaryColor}
            allowApplicantUploadsAfterDeadline={allowApplicantUploadsAfterDeadline}
            iteratableStepShowFirst={iteratableStepShowFirst}
            dependentConfigsForVariousSteps={dependentConfigsForVariousSteps}
            applicationId = {applicationId}
          />
          {applicationId && scholarship.allow_to_view_entire_steps__c && (isMobileScreen || isIpadScreen)  &&
        <JumptoSection
          handlejumpto={handlejumpto}
          currectStepId={currectStepId}
          getSections={getSections}
          buttonSecondaryColor={buttonSecondaryColor}
          submittedSteps = { submittedSteps }
          stepStatus = { stepStatus }
          isMobileOrIpad={isMobileScreen || isIpadScreen}
        />
      }
      </form>
)
}

ExternalRoleForm.propTypes = {
  scholarship: PropTypes.shape({
    allow_to_view_entire_steps__c: PropTypes.bool,
  }),
  isMobileScreen: PropTypes.bool,
  isIpadScreen: PropTypes.bool
}

export default ExternalRoleForm;